import React, { Component } from "react";
import Skeleton from "react-loading-skeleton";
import _ from "lodash";
import { Modal, Button } from "react-bootstrap";
import DetailItem from "../../../components/detailItem";

interface ICollectionSettingDetailProps {
  showDetailsModal: boolean;
  toggleDetailsModal: any;
  toggleEditModal: any;
  // togglePatchModal: any;
  showTrail: any;
  item: any;
}

interface ICollectionSettingDetailState {
  item: any;
  updatingStatus: boolean;
}

class CollectionSettingDetail extends Component<
  ICollectionSettingDetailProps,
  ICollectionSettingDetailState
> {
  constructor(props: ICollectionSettingDetailProps) {
    super(props);
    this.state = {
      item: {},
      updatingStatus: false
    };
  }

  static getDerivedStateFromProps(
    nextProps: ICollectionSettingDetailProps,
    prevState
  ) {
    // console.log("current props: ", nextProps.item);
    return {
      item: nextProps.item,
    };
  }

  render() {
    const {
      showDetailsModal,
      toggleDetailsModal,
      toggleEditModal,
      // togglePatchModal,
      showTrail,
      item,
    } = this.props;
    const { updatingStatus } = this.state;
    return (
      <Modal
        size="xl"
        backdrop="static"
        show={showDetailsModal}
        onHide={toggleDetailsModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {_.isEmpty(item) ? (
              <Skeleton width={500} />
            ) : (
              <h5>
                <i className="icon icon--columns s-18 mr-3" />
                Setting Details -{" "}
                <span className="font-weight-bold">{item.institutionCategory}</span>
              </h5>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card">
            <div className="card-header clear-fix">
              {_.isEmpty(item) ? (
                <Skeleton width={200} />
              ) : (
                <h6
                  className="card-title float-left"
                  style={{ marginBottom: "0px" }}
                >
                  <b>General Information</b>
                </h6>
              )}
              {/* <div className="float-right">
                {_.isEmpty(item) ? (
                  <Skeleton width={100} />
                ) : (
                  <span
                    className="badge btn-primary"
                    onClick={showTrail}
                    style={{
                      cursor: "pointer",
                      visibility: currentUserRoles.includes(
                        "viewaudittrailitems"
                      )
                        ? "visible"
                        : "hidden",
                    }}
                  >
                    View Trail
                  </span>
                )}
              </div> */}
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  {_.isEmpty(item) ? (
                    <Skeleton count={2} width={300} />
                  ) : (
                    <dl className="row">
                      <DetailItem
                        label="Category"
                        value={item.institutionCategory}
                        labelSize={5}
                        valueSize={7}
                      />
                      <DetailItem
                        label="Retry Period Interval"
                        value={item.retryPeriodInterval}
                        labelSize={5}
                        valueSize={7}
                      />
                    </dl>
                  )}
                </div>
                <div className="col-md-6">
                  {_.isEmpty(item) ? (
                    <Skeleton count={2} width={300} />
                  ) : (
                    <dl className="row">
                      <DetailItem
                        label="Max. Collection Retry Per Day"
                        value={item.maxCollectionRetryPerDay}
                        labelSize={5}
                        valueSize={7}
                      />
                      <DetailItem
                        label="Max. Collection Pauses Per Schedule"
                        value={item.maxCollectionPausesPerSchedule}
                        labelSize={5}
                        valueSize={7}
                      />
                    </dl>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {_.isEmpty(item) ? (
            <Skeleton width={100} count={2} height={30} />
          ) : (
            <React.Fragment>
              {/* {item.status === "Inactive" &&
                getCurrentUsersRoles().includes("activateocminstitution") && (
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    disabled={updatingStatus}
                    onClick={(e) =>
                      this.onHandleEnableOrDisable(e,ActionTypes.ACTIVATE,"Blackbox Institution")
                    }
                  >
                    <i className="far fa-edit mr-3" />
                    Activate
                  </Button>
              )}
              {item.status === "Active" &&
                getCurrentUsersRoles().includes("deactivateocminstitution") && (
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    disabled={updatingStatus}
                    onClick={(e) =>
                      this.onHandleEnableOrDisable(e, ActionTypes.DEACTIVATE,"Blackbox Institution")
                    }
                  >
                    <i className="far fa-edit mr-3" />
                    Deactivate
                  </Button>
              )} */}
              {/* {getCurrentUsersRoles().includes("editocminstitution") && ( */}
                <Button
                  size="sm"
                  variant="primary"
                  disabled={updatingStatus}
                  onClick={toggleEditModal}
                >
                  <i className="far fa-edit mr-3" />
                  Edit
                </Button>
              {/* )} */}
            </React.Fragment>
          )}

          <Button
            size="sm"
            variant="outline-danger"
            onClick={toggleDetailsModal}
          >
            <i className="fas fa-times mr-3" />
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default CollectionSettingDetail;
